import axios from 'axios';

const origin = `${process.env.VUE_APP_ORIGIN}`;
const prefix = 'api';

const routes = {
  get: {
    customerRecords: `${origin}/${prefix}/customer-records`,
  },
};

const getCustomerRecords = ({ userTokens = [] }) => {
  const params = new URLSearchParams({
    userTokens: userTokens.join(','),
  }).toString();

  const url = routes.get.customerRecords + '?' + params;

  return axios.get(url);
};

export { getCustomerRecords };
